import './Weather.css';
interface ICardWeatherProps {
    Title: string;
    Low: string;
    High: string;
    icon: string;
}

const CardWeather: React.FC<ICardWeatherProps> = (props) => {
    return (
        <div className="CardWeatherOuter">
            <div className="CardWeatherIcon">
                <img src={`http://openweathermap.org/img/w/${props.icon}.png`} height={55} width={55} />
            </div>
            <div className="CardWeatherInner">
                <div className="CardWeatherTitle">{props.Title}</div>
                <div className="CardWeatherInfo">
                    {props.Low}°C / {props.High}°C
                </div>
            </div>
        </div>
    );
};

export default CardWeather;
